query GetUserNames {
    users {
        edges {
            node {
                id
                name
            }
        }
    }
}
